import "./assets/css/vendor/bootstrap.min.css";
import "./assets/css/vendor/style.css";

let render = () => {
  require("./AppRenderer");
  };

render();